import React, { useEffect, useState } from "react";

const positions = ["Vänsterforward", "Center", "Högerforward", "Vänsterback", "Högerback", "Forward", "Back", "Målvakt"];

export default function PlayerPosition({ player, onChange }) {
    const [data, setData] = useState(null);
    const [choice, setChoice] = useState("");
    const [busy, setBusy] = useState(false);
    const [notice, setNotice] = useState("");
    const [failed, setFailed] = useState(false);
    const [retry, setRetry] = useState(0);
    const original = player.official_position ?? player.position ?? "";
    useEffect(() => {
        const controller = new AbortController();
        setFailed(false);
        fetch(`/hockey/api/sportsim/player-positions/${player.position_key}`, { signal: controller.signal })
            .then((response) => { if (!response.ok) throw new Error(); return response.json(); })
            .then((value) => { setData(value); setChoice(value.my_position || ""); })
            .catch((error) => { if (error.name !== "AbortError") setFailed(true); });
        return () => controller.abort();
    }, [player.position_key, retry]);
    const save = async (position) => {
        setBusy(true);
        setNotice("");
        try {
            const response = await fetch(`/hockey/api/sportsim/player-positions/${player.position_key}`, {
                method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ position }),
            });
            if (!response.ok) throw new Error();
            const value = await response.json();
            setData(value);
            setChoice(value.my_position || "");
            onChange(value.position, original);
            setNotice(position ? "Tack! Din position är sparad." : "Ditt bidrag är borttaget.");
        } catch { setNotice("Kunde inte spara. Försök igen."); }
        finally { setBusy(false); }
    };
    return <div className="player-position">
        <strong>Position: {(data ? data.position || original : player.position || original) || "Ej angiven"}</strong>
        <details><summary>Ändra position</summary>
        {failed ? <p>Kunde inte hämta bidragen. <button type="button" onClick={() => setRetry(retry + 1)}>Försök igen</button></p> : !data ? <p>Hämtar positioner…</p> : <>
            <p>Var spelar {player.name.split(" ")[0]}?</p>
            <details><summary>Visa ursprunglig position</summary><p>Swehockey: {original || "Ej angiven"}</p><p>Flest röster avgör den visade positionen. Vid lika används den ursprungliga.</p></details>
            <form onSubmit={(event) => { event.preventDefault(); save(choice); }}>
                <label htmlFor="player-position-choice">Din position</label>
                <select id="player-position-choice" value={choice} disabled={busy} onChange={(event) => setChoice(event.target.value)}>
                    <option value="" disabled>Välj position</option>
                    {positions.map((position) => <option key={position}>{position}</option>)}
                </select>
                <button type="submit" disabled={busy || !choice || choice === data.my_position}>{busy ? "Sparar…" : "Spara position"}</button>
                {data.my_position && <button type="button" disabled={busy} onClick={() => save(null)}>Ta bort mitt bidrag</button>}
            </form>
        </>}
        <p role="status">{notice}</p>
        </details>
    </div>;
}
